import React from 'react'
import styled from 'styled-components'
import { Box, Text as ChakraText } from '@chakra-ui/react'

const Wrapper = styled(Box)`
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  min-height: 320px;
`

const Title = styled(Box)`
  margin-top: -8vh;
  font-weight: bold;
  color: black;
  font-size: 3.375rem;

  span {
    font-size: 3.125rem;
  }
`

const ErrorLayout = ({
  error,
  componentStack,
}: {
  error: Error
  componentStack: string | null
}): React.ReactElement => (
  <Wrapper>
    <Title>Something went wrong.</Title>
    <ChakraText>
      We keep track of these errors, but feel free to contact us if refreshing
      doesn't fix things
    </ChakraText>
    {(window.env ?? 'dev') === 'dev' ? (
      <ChakraText>
        <pre>{error.name.toString()}</pre>
        <pre>{error.message.toString()}</pre>
      </ChakraText>
    ) : null}
  </Wrapper>
)

export default ErrorLayout
